<div class="flex flex-wrap items-center justify-between gap-y-24 bg-secondary-greys-white px-[60px] py-20">
  <div class="flex gap-8">
    <div class="text-[32px] font-light leading-[32px] tracking-[var(--letter-spacing-default)] text-brand-700">
      dCarbonizer
    </div>
    <svg-icon src="images/Layer_1.svg"></svg-icon>
  </div>
  <app-button-primary label="Explore Low-Carbon Solutions" (buttonClicked)="userService.login()"></app-button-primary>
</div>
